import React from 'react';

import { Button, Radio, DatePicker, Input, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
// import * as CurrencyFormat from 'react-currency-format';
import { comma } from 'utils/comma';
import CurrencyFormat from 'react-number-format';
import moment from 'moment';
import AddressPost from 'vcomponents/AddressPost/index2';

export const won = (props) => {
  const { prefix = '₩' } = props;
  return (
    <CurrencyFormat
      displayType={'input'}
      customInput={Input}
      prefix={prefix}
      thousandSeparator={true}
      value={props.value}
      disabled={props.disabled}
      onValueChange={({ value }) => props.onChange(value)}
    />
  );
};

export const number = (props) => {
  const { prefix = '', value, children } = props;
  const v = value || children || 0;
  return <div style={{ textAlign: 'right' }}>{`${prefix}${v && comma(v)}`}</div>;
};

export const crn = (props) => {
  return (
    <CurrencyFormat
      displayType={'input'}
      customInput={Input}
      format="###-##-#####"
      value={props.value}
      disabled={props.disabled}
      onValueChange={({ value }) => props.onChange(value)}
    />
  );
};

export const cell = (props) => {
  const { onChange = () => {} } = props;
  return (
    <CurrencyFormat
      displayType={'input'}
      placeholder="000-0000-0000"
      customInput={Input}
      format="###-####-####"
      value={props.value}
      disabled={props.disabled}
      onValueChange={({ value }) => onChange(value)}
    />
  );
};

export const download = (props) => {
  return (
    <a href={props.value} target="_blank">
      <Button type="primary" icon={<DownloadOutlined translate="" />}>
        Download
      </Button>
    </a>
  );
};

// export const crn = props=>{
//     return <CurrencyFormat displayType={'input'} format="###-##-#####" {...props} />
// }

export const datetime_str = (props) => {
  return <div style={props.style}>{props.value && moment(props.value).format('YYYY-MM-DD HH:mm:ss')}</div>;
};

export const date_str = ({ style, value, format = 'YYYY-MM-DD' }) => {
  return <div style={style}>{value && moment(value).format(format)}</div>;
};

export const datetime = (props) => {
  return (
    <Space direction="horizontal" size={12}>
      <DatePicker showTime {...props} />
    </Space>
  );
};

export const address = (props) => {
  return <AddressPost {...props} visibleLabel={false} />;
};

export const dateFormatStr = (props) => {
  const { placeholder, value, ...other } = props;
  return (
    <CurrencyFormat
      displayType="input"
      customInput={Input}
      format="####-##-##"
      placeholder={placeholder || 'YYYY-MM-DD'}
      mask={['Y', 'Y', 'Y', 'Y', 'M', 'M', 'D', 'D']}
      onValueChange={({ value: v }) => props.onChange(v)}
      value={value === null ? undefined : value}
      {...other}
    />
  );
};
